// extracted by mini-css-extract-plugin
export default {"newslettersection":"Newsletter_newslettersection__n6d6n","appear":"Newsletter_appear__xuqqA","newsletterform":"Newsletter_newsletterform__rxzxO"};